import React, {createContext, useContext, useState} from "react";
import axios from "axios";
import jwtDecode from "jwt-decode";

const authContext = createContext();

export function ProvideAuth({children}) {
    const auth = useProvideAuth();
    return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

export const useAuth = () => {
    return useContext(authContext);
};

// Provider hook that creates auth object and handles state
function useProvideAuth() {
    const [user, setUser] = useState(false);
    const [signinError, setSigninError] = useState("");
    const [remember, setRemember] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const signin = (email, password) => {
        axios
            .post(`${process.env.REACT_APP_API_LINK}/auth/user/sign_in/`, {
                email,
                password,
            })
            .then((response) => {
                if (response.status !== 400) {
                    localStorage.setItem("accessToken", response.data.access);
                    localStorage.setItem("refreshToken", response.data.refresh);
                    let decoded = jwtDecode(response.data.access);
                    setUser(decoded);
                }
            })
            .catch((error) => {
                setSigninError(JSON.parse(error.request.response).detail);
            });
    };
    const signout = () => {
        setUser(false);
        localStorage.clear();
        sessionStorage.clear();
    };

    const refreshToken = () => {
        setIsLoading(true);
        let refreshToken = localStorage.getItem("refreshToken");
        if (localStorage.getItem("rememberUser") && refreshToken) {
            axios
                .post(`${process.env.REACT_APP_API_LINK}/auth/token/refresh/`, {
                    refresh: refreshToken,
                })
                .then((response) => {
                    if (response.status === 200) {
                        localStorage.setItem("accessToken", response.data.access);
                        setUser(true);
                    } else {
                        localStorage.clear();
                        setUser(false);
                    }
                });
        }
        setIsLoading(false);
    };

    // Return the user object and auth methods
    return {
        user,
        signin,
        refreshToken,
        signout,
        signinError,
        remember,
        setRemember,
        isLoading,
    };
}

// const signup = (email, password) => {
//     return firebase
//         .auth()
//         .createUserWithEmailAndPassword(email, password)
//         .then((response) => {
//             setUser(response.user);
//             return response.user;
//         });
// };
